module.exports = __webpack_public_path__ + "img/latelier-montaigu.2dfd4e29.png";